import { getHostname, Environment, isDevHost, isCloverProdEnvironment } from 'utils/Environment';

const scriptMap: Record<Environment, string | Record<string, string>> = {
  test: 'https://checkout.dev1.dev.clover.com/sdk.js',
  // since all dev*, stg* and sandbox use prod build, hence keeping them inside production
  production: {
    clover: 'https://checkout.clover.com/sdk.js',
    dev1: 'https://checkout.dev1.dev.clover.com/sdk.js',
    sandbox: 'https://checkout.sandbox.dev.clover.com/sdk.js',
    stg1: 'https://checkout.stg1.dev.clover.com/sdk.js'
  },
  development: 'https://checkout.dev1.dev.clover.com/sdk.js'
} as const;

const getScriptUrl = (environment: Environment): string => {
  const hostName: string = getHostname().split('.')[0];
  if (environment === 'production') {
    const productionMap = scriptMap[environment] as Record<string, string>;
    // return dev1 script url for netlify or any other dev host
    if (isDevHost()) {
      return productionMap['dev1'];
    }

    if (isCloverProdEnvironment()) {
      return productionMap['clover'];
    }

    const isEnvironmentPresent = Object.keys(productionMap).includes(hostName);
    if (!isEnvironmentPresent) {
      console.error(`Tokenization not configured for ${hostName} environment`);
    }

    return productionMap[hostName];
  }

  return scriptMap[environment] as string;
};

const pakmsKeyMap: Record<Environment, string | Record<string, string>> = {
  test: '7e525404872b8186b82b5057cfacebff',
  // since all dev*, stg* and sandbox use prod build, hence keeping them inside production.
  production:  {
    clover: 'bc22012281f7c86f7aa9b5c865b718c0',
    dev1: '88234a49d5fc111d7361c29d257fb117',
    sandbox: '22e11ddb3454b409d0209ca87937f7f7',
    stg1: '73369724c43415e84578eaadf9d79abf'
  },
  development: '88234a49d5fc111d7361c29d257fb117'
};

const getPakmsKey = (environment: Environment): string => {
  const hostName: string = getHostname().split('.')[0];
  if (environment === 'production') {
    const productionMap = pakmsKeyMap[environment] as Record<string, string>;
    if (isDevHost()) {
      return productionMap['dev1'];
    }

    if (isCloverProdEnvironment()) {
      return productionMap['clover'];
    }

    const isEnvironmentPresent = Object.keys(productionMap).includes(hostName);
    if (!isEnvironmentPresent) {
      console.error(`Pakms key not configured for ${hostName} environment`);
    }

    return productionMap[hostName];
  }

  return pakmsKeyMap[environment] as string;
};

export {
  getPakmsKey,
  getScriptUrl,
};

